// A breakout's LiveKit room is `<session room>:breakout:<id>`: the only shape the
// hub opens one under (XN-4823). A title loses its colons, so no session's room
// can take a breakout's name. The id is new every time, so a room retired in an
// edit or an earlier run, which may still hold people who missed the move, is
// never handed to a new group. The display name stays a label.
export function breakoutRoomName(mainRoom) {
  return `${mainRoom}:breakout:${crypto.randomUUID().replace(/-/g, '').slice(0, 12)}`;
}
